import React from "react";
import { BookWrap, InsiderCard } from "components/common/candidate";
import { Stripe, Cards, ObjectivesCard, PromoCode } from "./components";

export default ({
  isLoading,
  booking,
  applyPromoCode,
  deleteObjective,
  cards,
  coupon,
  createCard
}) => (
  <BookWrap
    step="checkout"
    isLoading={isLoading}
    title="Billing details"
    bigTitle="CompleteBooking"
    sidebar={
      <React.Fragment>
        <InsiderCard {...booking.insider} {...booking} />
        <ObjectivesCard deleteObjective={deleteObjective} {...booking} />
      </React.Fragment>
    }
  >
    {() => (
      <div className="ph5-ns ph0">
        {!cards.data.results.length ? (
          <div>
            <Stripe
              onGetToken={createCard("first")}
              completeText="FINALIZE BOOKING"
              total={
                <div className="flex justify-between mt2 ph0-ns ph3">
                  <div
                    style={{ fontFamily: "CircularStd-Book", fontSize: "21px" }}
                  >
                    Total Cost
                  </div>
                  <div
                    style={{ fontFamily: "CircularStd-Book", fontSize: "21px" }}
                  >
                    {coupon.data
                      ? coupon.data.discounted_price
                      : booking.total_price}
                  </div>
                </div>
              }
              promoCode={<PromoCode applyPromoCode={applyPromoCode} />}
            />
          </div>
        ) : (
          <React.Fragment>
            <Cards
              onGetToken={createCard("another")}
              cost={
                <div className="flex justify-between mt2 ph0-ns ph3">
                  <div
                    style={{ fontFamily: "CircularStd-Book", fontSize: "21px" }}
                  >
                    Total Cost
                  </div>
                  <div
                    style={{ fontFamily: "CircularStd-Book", fontSize: "21px" }}
                  >
                    {coupon.data
                      ? coupon.data.discounted_price
                      : booking.total_price}
                  </div>
                </div>
              }
              promo_code={<PromoCode applyPromoCode={applyPromoCode} />}
              cards={cards.data.results}
            />
          </React.Fragment>
        )}
      </div>
    )}
  </BookWrap>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/Payment/View.js